import { ChatModuleType } from '../copied/models/ChatModules';
import useFetchHelpCenter from './fetch/useFetchHelpCenter';

export default function useTermOfUseDisclaimer() {
  const { data: helpCenter } = useFetchHelpCenter();
  const tou = helpCenter?.modules?.find((module) => module.module_type === ChatModuleType.TermsOfUse);

  return tou?.header_title || null;
}
